module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-478.7abf51d.woff2";